import React, { useState } from 'react'
import logo from '../assets/images/logo.svg'
import { NavLink } from 'react-router-dom'
import 'bootstrap/js/dist/button'

function Header() {
  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(true)

  const toggleNavbar = () => {
    setIsNavbarCollapsed(!isNavbarCollapsed)
  }

  return (
    <header id="header" className="header fixed-top">
      <nav className="navbar navbar-expand-lg ">
        <div className="container">
          <NavLink className="navbar-brand" to="/">
            <img className="logo" src={logo} alt="logo" />
          </NavLink>
          <button
            className="navbar-toggler ms-auto"
            type="button"
            onClick={toggleNavbar}
            aria-controls="navbarCollapse"
            aria-expanded={!isNavbarCollapsed}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div
            className={`collapse navbar-collapse ${isNavbarCollapsed ? '' : 'show'}`}
            id="navbarCollapse"
          >
            <div className="ms-auto">
              <ul className="navbar-nav mb-2 mb-md-0 d-flex align-items-center">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/projects">
                    Projects
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/howwework">
                    How We Work
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/ourprinciples">
                    Our Principles
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/ourpartnerships">
                    Our Partnerships
                  </NavLink>
                </li>

                <li className="nav-item d-none d-lg-block">
                  <NavLink className="btn-outline-22" to="/contactus">
                    Contact Us
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Header
